<template>
  <Badge :class="enumClass" variant="custom">
    {{ enumLabel }}
  </Badge>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Badge } from '@/components/ui/badge';
import type { CellContext } from '@tanstack/vue-table';

const props = defineProps<{
  info: CellContext<any, any>;
  enumOptions: {
    label: string;
    value: string;
    class?: string;
  }[];
}>();

const enumLabel = computed(() => {
  const value = props.info.getValue();
  const order = props.info.row.original;
  const label = props.enumOptions.find(option => option.value === value)?.label;
  if (!order.is_restrict || order.status_display !== 'CLEARING') {
    return label;
  }

  return `${label} (${order.total_clearer_approved || 0} / ${order.total_clearer || 0})`;
});

const enumClass = computed(() => {
  const value = props.info.getValue();
  return props.enumOptions.find(option => option.value === value)?.class;
});
</script>
